<app-main-nav-bar></app-main-nav-bar>
<app-map (locationChanged)="setLocation($event)" [locations]="locations"
         (showNavigation)="showNavigation=true"
         (clearLocations)="clearLocations()"
         #mapComponent
></app-map>
<div class="col-12 tool-box" style="margin-bottom: 112px;">

  <app-select-field
    [fieldName]="'companyName'"
    [fieldLabel]="'شرکت'"
    [Group]="searchForm"
    [options]="companies"
    (OnChange)="getTypesList()"
  ></app-select-field>
  <app-select-field
    [fieldName]="'type'"
    [fieldLabel]="'نوع مرکز'"
    [Group]="searchForm"
    [options]="types"
  ></app-select-field>

  <app-input-field
    [disabled]="false"
    [Group]="searchForm"
    [fieldLabel]="'حد اکثر فاصله (کلومتر)'"
    [fieldName]="'distance'"
    [dataType]="['number']"
    [Icon]="true"
  ></app-input-field>

  <app-custom-button [HideMainButton]="false"
                     [disabled]="!searchForm.valid"
                     [Show]="true"
                     [LabelText]="'جست و جو'"
                     [BackButton]="false"
                     (OnClick)="search()"
  ></app-custom-button>
</div>
<div class="mobileOnly">
  <app-custom-button [BackButton]="!(!locations.length)"
                     [LabelText]="'موقعيت خودم'"
                     [Show]="true"
                     [disabled]="false"
                     [mode]="'BOTTOM'"
                     [HideMainButton]="false"
                     (OnClick)="goToCurrentLocation()"
  ></app-custom-button>
</div>
<div *ngIf="isLoaded">
  <app-navigation [showCondition]="showNavigation"
                  [feature]="getSelectedFeature()"
                  (ClickOutSide)="showNavigation = false"
                  (getNavigation)="showRoute($event)"
  ></app-navigation>
</div>

